<template>
  <div
    v-if="isDiscountEdit"
    class="total-discount__wrapper"
    v-bind:class="initialDiscountType"
  >
    <input-discount
      v-on:keypress.native="onKeypress"
      class="total-discount__input"
      ref="inputDiscount"
      v-bind:discount-type="initialDiscountType"
      v-bind:max-discount-in-kop="maxDiscount"
      v-bind:show-discount-postfix="false"
      v-model="inputValue"
      v-on:blur="onBlur"
    />
  </div>
  <button
    v-else
    class="total-discount"
    type="button"
    v-bind:disabled="disabled"
    v-on:click="onClick"
    title="Изменить общую скидку"
  >
    <the-rub
      v-bind:show-kop="$options.SHOW_KOP_AUTO"
      class="total-discount__value"
      v-bind:kop="value"
      currency="тнг"
    />
  </button>
</template>

<script>
import InputDiscount from '@/components/InputDiscount.vue';
import TheRub, { SHOW_KOP_AUTO } from '@/components/TheRub.vue';
import focusMixin from '@/mixins/focusMixin';
import { DISCOUNT_IN_KOPECK } from '@/components/SwitchDiscountType.vue';

/**
 * @description Компонент поля ввода общей скидки.
 * @type {Vue}
 */
export default {
  SHOW_KOP_AUTO,
  components: { TheRub, InputDiscount },
  data() {
    return {
      /**
       * @description Начальное введенное значение суммы скидки.
       * @type {number}
       */
      initialInputValue: 0,
      /**
       * @description Введенное значение суммы скидки.
       * @type {number}
       */
      inputValue: 0,
      /**
       * @description Редактирование скидки.
       * @type {boolean}
       */
      isDiscountEdit: false,
    };
  },
  methods: {
    /**
     * @description Обработать потерю фокуса.
     * @returns {void}
     */
    onBlur() {
      this.isDiscountEdit = false;
      if (this.inputValue !== this.initialInputValue) {
        this.$emit('change', this.inputValue);
      }
    },
    /**
     * @description Обработать нажатие.
     * @returns {void}
     */
    onClick() {
      if (this.initialDiscountType === DISCOUNT_IN_KOPECK) {
        this.inputValue = Math.round(this.initialDiscount);
      } else if (this.maxDiscount === 0) {
        this.inputValue = 0;
      } else {
        const percent = (100 / this.maxDiscount) * this.initialDiscount;
        this.inputValue = Math.round(percent);
      }
      this.initialInputValue = this.inputValue;
      this.isDiscountEdit = true;
      this.$nextTick(() => {
        this.focusIn(this.$refs.inputDiscount.$el);
      });
    },
    /**
     * @description Обработать нажатие клавиши.
     * @param {KeyboardEvent} event
     * @returns {void}
     */
    onKeypress(event) {
      if (event.code === 'Enter') {
        event.preventDefault();
        this.onBlur();
      }
    },
  },
  mixins: [focusMixin],
  name: 'InputTotalDiscount',
  props: {
    /**
     * @description Неактивно.
     */
    disabled: { default: true, type: Boolean },
    /**
     * @description Максимальная скидка.
     */
    maxDiscount: { required: true, type: Number },
    /**
     * @description Значение скидки.
     */
    value: { required: true, type: Number },
    /**
     * @description Скидка без учета бесплатных услуг.
     */
    initialDiscount: { required: true, type: Number },
    /**
     * @description Тип скидки.
     */
    initialDiscountType: { required: true, type: String },
  },
};
</script>

<style lang="scss">
.total-discount {
  text-align: left;
  border-bottom: 1px solid transparent;
  &__wrapper {
    position: relative;
    display: inline-block;
    width: 4rem;
  }
  &__input {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    & > input {
      &:focus {
        color: #212529;
        border-bottom: 1px solid #0489e0;
        outline: 0;
        padding: 0;
      }
      &:disabled {
        color: #212529;
        cursor: default;
      }
    }
  }
  &__value {
    color: var(--action-color);
  }
  &:disabled &__value {
    color: var(--reading-color);
  }
}
</style>
